import { render } from "./StatsSection.vue?vue&type=template&id=088c4eb4&scoped=true"
import script from "./StatsSection.vue?vue&type=script&lang=js"
export * from "./StatsSection.vue?vue&type=script&lang=js"

import "./StatsSection.vue?vue&type=style&index=0&id=088c4eb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088c4eb4"]])

export default __exports__